import {
	type ApiClientError,
	ErrorCode,
	type ErrorMiddleware,
	type Middleware,
} from "@jace/api";
import { DevLogger } from "../logger";
import type { GetTokenCallable } from "./types";

class MissingTokenError extends Error {
	constructor() {
		super("Missing token");

		this.name = "MissingTokenError";
	}
}

export const createAuthMiddleware = (
	getToken: GetTokenCallable,
	onError?: () => void,
): Middleware => {
	const authMiddleware: Middleware = {
		async onRequest(request: Request): Promise<Request> {
			const token = await getToken();

			if (!token) {
				const error = new MissingTokenError();
				DevLogger.error(error);

				if (onError) {
					onError();
				} else {
					throw error;
				}
			}

			request.headers.set("Authorization", `Bearer ${token}`);

			return request;
		},
	};

	return authMiddleware;
};

export const createUnauthorizedErrorMiddleware = (
	cb: () => void,
): ErrorMiddleware => ({
	onError: async (error: ApiClientError): Promise<void> => {
		try {
			if (error.status === ErrorCode.Unauthorized) {
				DevLogger.info("Unauthorized");
				cb();
			}
		} catch (e) {
			DevLogger.error(e, { message: `Error in ApiClient Middleware` });
		}
	},
});
